import { PageHeader } from '@/shared/components/ui/PageHeader';
import { Headphones } from 'lucide-react';
import { useUser } from '@/shared/hooks/useAuth';
import { SessionCard } from '../components/SessionCard';
import { BreakControls } from '../components/BreakControls';
import { TeamMonitor } from '../components/TeamMonitor';

export function CallCenterPage() {
  const user = useUser();
  const isPrivileged = ['admin', 'superadmin'].includes(user?.role ?? '');

  return (
    <div className="flex h-full flex-col gap-4 pb-16">
      <PageHeader
        icon={Headphones}
        eyebrow="Marketing"
        title="Call Center"
        description={<>Your call session, breaks, and team activity.</>}
      />

      {/* Self view — all roles */}
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <SessionCard />
        <BreakControls />
      </div>

      {/* Team monitoring — admin / superadmin only (mirrors backend) */}
      {isPrivileged && <TeamMonitor enabled={isPrivileged} />}
    </div>
  );
}
